export default __webpack_public_path__ + "static/media/mp_merch_pres1.8c5f1cf0.svg";